import React, { useCallback } from 'react'
import { alerts as alertKeys, statusTypeCategories, queryClient as qc } from 'keys'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { updateStuckStatusFetch } from 'store/middlewares/assessment.crud'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { markingWordsHooks } from './MarkingWords'
import StatusTypeReasonAlert from './StatusTypeReasonAlert'
import { useAlert } from 'components/Alerts/hooks'

// בכוונה לא נוגע ב-status/sub_status - המבדק נשאר ניתן להמשך סימון בדיוק כמו מבדק
// שנמצא ב"בסימון" (ולא מוצג שם בפועל, כי הוא מוסתר מרשימות אחרות כל עוד הוא תקוע).
// הניווט חזרה ל-markingWordsAssessments מספיק כשלעצמו - הטאב שהיה פתוח קודם
// (למשל "ממתינים לסימון") משוחזר לבד דרך TranscriptionSystemContext, בלי לגעת בזה כאן
const StuckReasonAlert = () => {
    const { assessment } = useSelector(state => state.assessment)
    const queryClient = useQueryClient()
    const { setAlerts } = useAlert()
    const navigate = useNavigate()

    const { saveDraft } = markingWordsHooks.useSaveDraft()

    const { mutateAsync: updateStuckStatus, isPending: updateStuckStatusLoading } = useMutation({
        mutationFn: updateStuckStatusFetch,
        onError: () => {
            setAlerts(alertKeys.stuckReason, false)
            toast.error("בעייה בעדכון", toastConfig)
        }
    })

    const markStuck = useCallback(async (statusType) => {
        await saveDraft()
        await updateStuckStatus({ id: assessment?.id, stuck_reason: statusType.id })
        queryClient.invalidateQueries({ queryKey: [qc.assessmentAndWords] })

        navigate(app.markingWordsAssessments)
    }, [assessment])

    return (
        <StatusTypeReasonAlert
            alertKey={alertKeys.stuckReason}
            title="מה סיבת התקיעות?"
            category={statusTypeCategories.stuck}
            onConfirm={markStuck}
            confirmLoading={updateStuckStatusLoading}
        />
    )
}

export default StuckReasonAlert
